import ScopeDetails from '../../ScopeDetails';
import { Scope } from '../../../helpers/Initiatives.types';

type Props = {
  data: Scope;
  isLoading: boolean;
};

const ScopeCol = ({ data, isLoading }: Props) => {
  return <ScopeDetails data={data} isLoading={isLoading} />;
};

export default ScopeCol;
